module.exports = __webpack_public_path__ + "static/q4answer4_cave_wishmas-f6d55cb84dd1439b04a09b10c9a063fc.jpg";